var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error error__404"},[_vm._v(" 404 not Found ")])
}
var staticRenderFns = []

export { render, staticRenderFns }